import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2'
import Breadcrumb from '../Component/Breadcrumb';
import Sidebar from '../../Dashboard/Component/Siderbar';
import Layout from '../../../Components/Layout';
import config from '../../../config';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
export default function List() {
    const [subAgencies, setSubAgencies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sortedData, setSortedData] = useState([]);
    const navigate = useNavigate();
    const location = useLocation(); 
    const [searchQuery, setSearchQuery] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
    const userData = JSON.parse(localStorage.getItem('user_data'));

    const fetchSubAgencies = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${config.API_BASE_URL_V1}agency/sub-agencies?page=1&per_page=100`,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                    },
                }
            );
            setSubAgencies(response.data.data);
            setSortedData(response.data.data);
        } catch (err) {
            setError(err.message);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err.response?.data?.message || 'Failed to fetch sub agencies',
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSubAgencies();
    }, []);

    console.log('subAgencies: ',subAgencies)

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
    
        const sorted = [...sortedData].sort((a, b) => {
            if (a[key] && b[key]) { 
                if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
                if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
            }
            return 0;
        });
    
        setSortedData(sorted);
        setSortConfig({ key, direction });
    };
    
    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
    
        const filtered = subAgencies.filter((agency) =>
            Object.values(agency).some((value) => 
                value && String(value).toLowerCase().includes(query)
            )
        );
        setSortedData(filtered);
    };

    const handleDisable = async (id) => {
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "You want to disable this sub agency?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, disable it!'
            });

            if (result.isConfirmed) {
                const response = await axios.post(
                    `${config.API_BASE_URL_V1}agency/status-sub-agency/${id}`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${userData.token}`,
                        },
                    }
                );

                if (response.data.status === "success") {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        timerProgressBar: true,
                        timer: 1500,
                        icon: "success",
                        title: "Successfully disabled!",
                        showConfirmButton: false,
                    });
                    fetchSubAgencies(); // Refresh the list
                } else {
                    throw new Error(response.data.message || "Failed to disable sub agency");
                }
            }
        } catch (error) {
            console.error("Error disabling sub agency:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.response?.data?.message || "Failed to disable sub agency",
            });
        }
    };

    const handleEnable = async (id) => {
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "You want to enable this sub agency?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, enable it!'
            });

            if (result.isConfirmed) {
                const response = await axios.post(
                    `${config.API_BASE_URL_V1}agency/status-sub-agency/${id}`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${userData.token}`,
                        },
                    }
                );

                if (response.data.status === "success") {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        timerProgressBar: true,
                        timer: 1500,
                        icon: "success",
                        title: "Successfully enabled!",
                        showConfirmButton: false,
                    });
                    fetchSubAgencies(); // Refresh the list
                } else {
                    throw new Error(response.data.message || "Failed to enable sub agency");
                }
            }
        } catch (error) {
            console.error("Error enabling sub agency:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.response?.data?.message || "Failed to enable sub agency",
            });
        }
    };

    if (loading) {
        return (
            <div id="loader-wrapper">
                <div id="loader">
                    <span className="loader-line"></span>
                </div>
            </div>
        );
    }

    return (
        <Layout>
            <Breadcrumb title="Sub Agency List"/>
            <div className="content">
                <div className="container">
                    <div className="row">
                        <Sidebar>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card booking-header border-0">
                                        <div className="card-body header-content d-flex align-items-center justify-content-between flex-wrap">
                                            <div>
                                                <h6 className="mb-1">Sub Agency</h6>
                                                <p className="fs-14 text-gray-6 fw-normal">Total : {subAgencies?.length}</p>
                                            </div>
                                            <div className="d-flex align-items-center flex-wrap">
                                                <button 
                                                    className='btn btn-primary'
                                                    onClick={() => navigate('/dashboard-sub-agency-add')}
                                                >
                                                    + Add Sub Agency
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card hotel-list" style={{ boxShadow:'0px 4px 24px 0px rgba(194, 194, 194, 0.25)' }}>
                                        <div className="card-body p-0">
                                            <div className="list-header d-flex align-items-center justify-content-between flex-wrap">
                                                <h6 className="">Sub Agency List</h6>
                                            </div>

                                            <div className="custom-datatable-filter table-responsive">
                                                {!loading && (
                                                    <>
                                                        {subAgencies?.length > 0 ? (
                                                            <>
                                                                <div className="mb-3" style={{ 
                                                                    paddingTop: "10px", 
                                                                    paddingInline: "10px",
                                                                    top: "0",
                                                                    backgroundColor: "white",
                                                                    zIndex: "1000",
                                                                }}>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Search agency..."
                                                                        value={searchQuery}
                                                                        onChange={handleSearch}
                                                                        style={{ width: "300px" }}
                                                                    />
                                                                </div>
                                                                <table className="datatable table">
                                                                    <thead className="thead-light">
                                                                        <tr>
                                                                            <th onClick={() => handleSort("agency_code")} style={{ cursor: "pointer" }}>
                                                                                Agency Code
                                                                            </th>
                                                                            <th onClick={() => handleSort("name")} style={{ cursor: "pointer" }}>
                                                                                Name
                                                                            </th>
                                                                            <th onClick={() => handleSort("email")} style={{ cursor: "pointer" }}>
                                                                                Email
                                                                            </th>
                                                                            <th onClick={() => handleSort("phone")} style={{ cursor: "pointer" }}>
                                                                                Phone
                                                                            </th>
                                                                            <th onClick={() => handleSort("markup")} style={{ cursor: "pointer" }}>
                                                                                Markup (%)
                                                                            </th>
                                                                            <th>Status</th>
                                                                            <th className="text-center">Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {sortedData.map((agency) => (
                                                                            <tr key={agency.id}>
                                                                                <td>{agency.agency_code}</td>
                                                                                <td>{agency.name}</td>
                                                                                <td>{agency.email}</td>
                                                                                <td>{agency.phone}</td>
                                                                                <td className="text-center">{agency.markup}</td>
                                                                                <td>
                                                                                    <span className={`badge ${agency.status ? 'badge-success' : 'badge-danger'}`}>
                                                                                        {agency.status ? 'Active' : 'Inactive'}
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                        <OverlayTrigger
                                                                                            placement="top"
                                                                                            overlay={<Tooltip>Edit Sub Agency</Tooltip>}
                                                                                        >
                                                                                            <button
                                                                                                className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                                                                                                onClick={() => navigate(`/dashboard-sub-agency-edit/${agency.id}`)}
                                                                                        >
                                                                                            <i className="isax isax-edit"></i>
                                                                                            Edit
                                                                                        </button>
                                                                                        </OverlayTrigger>
                                                                                        {agency.status ? (
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={<Tooltip>Disable Sub Agency</Tooltip>}
                                                                                            >
                                                                                                <button
                                                                                                    className="btn btn-danger btn-sm d-flex align-items-center gap-1"
                                                                                                onClick={() => handleDisable(agency.id)}
                                                                                            >
                                                                                                <i className="isax isax-close-circle"></i>
                                                                                                Disable
                                                                                            </button>
                                                                                        </OverlayTrigger>
                                                                                        ) : (
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={<Tooltip>Enable Sub Agency</Tooltip>}
                                                                                            >
                                                                                                <button
                                                                                                    className="btn btn-success btn-sm d-flex align-items-center gap-1"
                                                                                                onClick={() => handleEnable(agency.id)}
                                                                                            >
                                                                                                <i className="isax isax-tick-circle"></i>
                                                                                                Enable
                                                                                            </button>
                                                                                        </OverlayTrigger>
                                                                                        )}
                                                                                        <OverlayTrigger
                                                                                            placement="top"
                                                                                            overlay={<Tooltip>Credit Sub Agency</Tooltip>}
                                                                                        >
                                                                                            <button
                                                                                                className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                                                                                            onClick={() => navigate('/dashboard-sub-agency-wallet-history', {
                                                                                                state: { agencyId: agency.id }
                                                                                            })}
                                                                                        >
                                                                                            <i className="isax isax-wallet-3"></i>
                                                                                            Credit
                                                                                        </button>
                                                                                        </OverlayTrigger>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </>
                                                        ) : (
                                                            <div style={{ padding: "50px" }} className="d-flex justify-content-center align-items-center">
                                                                <p style={{ textAlign: "center", margin: "auto", width: "100%" }}>
                                                                    No sub agencies found.
                                                                </p>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Sidebar>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

